import React from "react";

export function TychiLogo({ variant = "light", size = 320 }) {
  const isLight = variant === "light";
  const textFill = isLight ? "#1a1a3e" : "#FFFFFF";
  const gradients = { g1: ["#3A3A8C","#2E2E78"], g2: ["#5E5EAE","#4F4F9A"], g3: ["#9090C8","#7E7EB8"] };

  const uid = `logo-${variant}-${Math.random().toString(36).slice(2,6)}`;

  return (
    <svg viewBox="0 0 520 120" width={size} height="auto" role="img" aria-label="Tychi Logo">
      <defs>
        <linearGradient id={`${uid}-b1`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={gradients.g1[0]} />
          <stop offset="100%" stopColor={gradients.g1[1]} />
        </linearGradient>
        <linearGradient id={`${uid}-b2`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={gradients.g2[0]} />
          <stop offset="100%" stopColor={gradients.g2[1]} />
        </linearGradient>
        <linearGradient id={`${uid}-b3`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={gradients.g3[0]} />
          <stop offset="100%" stopColor={gradients.g3[1]} />
        </linearGradient>
      </defs>
      <rect x="10" y="14" width="26" height="92" rx="4" fill={`url(#${uid}-b1)`} />
      <rect x="42" y="14" width="26" height="92" rx="4" fill={`url(#${uid}-b2)`} />
      <rect x="74" y="14" width="26" height="92" rx="4" fill={`url(#${uid}-b3)`} />
      <text x="122" y="92" fontFamily="'Helvetica Neue','Segoe UI',Helvetica,sans-serif"
        fontSize="82" fontWeight="300" letterSpacing="-1.5" fill={textFill}>Tychi</text>
    </svg>
  );
}

export function TychiIcon({ size = 40 }) {
  return (
    <svg viewBox="0 0 100 120" width={size} height="auto" role="img" aria-label="Tychi Icon">
      <defs>
        <linearGradient id="icon-b1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#3A3A8C" /><stop offset="100%" stopColor="#2E2E78" />
        </linearGradient>
        <linearGradient id="icon-b2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#5E5EAE" /><stop offset="100%" stopColor="#4F4F9A" />
        </linearGradient>
        <linearGradient id="icon-b3" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#9090C8" /><stop offset="100%" stopColor="#7E7EB8" />
        </linearGradient>
      </defs>
      <rect x="10" y="14" width="22" height="92" rx="3.5" fill="url(#icon-b1)" />
      <rect x="38" y="14" width="22" height="92" rx="3.5" fill="url(#icon-b2)" />
      <rect x="66" y="14" width="22" height="92" rx="3.5" fill="url(#icon-b3)" />
    </svg>
  );
}
